import { PrintHidden } from '#/components/PrintHidden/PrintHidden';
import { useEmbedSearchWidget } from '#/modules/embedSearchWidget/contexts/EmbedSearchWidgetContext';
import { SearchContextHeader } from '#/modules/search/components/Context/SearchContextHeader';
import type { SearchContextHeaderData } from '#/modules/search/containers/SearchContextHeader/SearchContextHeaderData';

import { SearchContextNavHolder } from './SearchContextNav.styled';

type Props = {
  searchContext: SearchContextHeaderData;
  position: 'top' | 'bottom';
  spaceBelow?: boolean;
};

export function SearchContextNav({
  searchContext,
  position,
  spaceBelow,
}: Props) {
  const { embedSearchWidget } = useEmbedSearchWidget();

  // Below 992px the header arrow replaces this bar
  const hideBelowMd = embedSearchWidget === null;

  return (
    <PrintHidden>
      <SearchContextNavHolder
        data-qa-id="search-context-nav"
        data-position={position}
        data-space-below={spaceBelow || undefined}
        data-hide-below-md={hideBelowMd || undefined}
      >
        <SearchContextHeader
          searchContext={searchContext}
          noDivider={position === 'bottom'}
        />
      </SearchContextNavHolder>
    </PrintHidden>
  );
}
